import { format, formatDistanceToNowStrict, isValid, parseISO } from "date-fns";
import { be, enUS, ru } from "date-fns/locale";

const locales = {
  be,
  en: enUS,
  ru
};

export function formatDateTime(value: string | Date | null | undefined, language: string) {
  const date = normalizeDate(value);
  if (!date) {
    return "—";
  }
  const locale = locales[language as keyof typeof locales] ?? ru;
  return format(date, "dd.MM.yyyy HH:mm", { locale });
}

export function relativeDateTime(value: string | Date | null | undefined, language: string) {
  const date = normalizeDate(value);
  if (!date) {
    return "—";
  }
  const locale = locales[language as keyof typeof locales] ?? ru;
  return formatDistanceToNowStrict(date, { addSuffix: true, locale });
}

export function isOlderThanHours(value: string | Date | null | undefined, hours: number) {
  const date = normalizeDate(value);
  if (!date) {
    return true;
  }
  return Date.now() - date.getTime() > hours * 60 * 60 * 1000;
}

export function formatDateInput(value: Date | null | undefined) {
  if (!value || !isValid(value)) {
    return "";
  }
  return format(value, "yyyy-MM-dd");
}

export function parseDateInput(value: string | null | undefined) {
  if (!value) {
    return undefined;
  }
  const date = parseISO(value);
  return isValid(date) ? date : undefined;
}

function normalizeDate(value: string | Date | null | undefined) {
  if (!value) {
    return null;
  }
  const date = value instanceof Date ? value : parseISO(value);
  return isValid(date) ? date : null;
}
